
// This file contains blog post data with translations for all supported languages

export const blogPosts = [
  {
    id: 1,
    slug: "ki-videomarketing-revolution",
    date: "12.04.2025",
    image: "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "So revolutioniert KI das Videomarketing",
      en: "How AI is Revolutionizing Video Marketing",
      fr: "Comment l'IA révolutionne le marketing vidéo",
      it: "Come l'IA sta rivoluzionando il video marketing"
    },
    excerpt: {
      de: "Entdecken Sie, wie künstliche Intelligenz die Erstellung von Marketingvideos vereinfacht und beschleunigt.",
      en: "Discover how artificial intelligence simplifies and accelerates the creation of marketing videos.",
      fr: "Découvrez comment l'intelligence artificielle simplifie et accélère la création de vidéos marketing.",
      it: "Scopri come l'intelligenza artificiale semplifica e accelera la creazione di video di marketing."
    }
  },
  {
    id: 2,
    slug: "vorteile-ai-erklaervideos",
    date: "05.04.2025",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "5 Vorteile von AI-Erklärvideos für Unternehmen",
      en: "5 Benefits of AI Explainer Videos for Businesses",
      fr: "5 avantages des vidéos explicatives IA pour les entreprises",
      it: "5 vantaggi dei video esplicativi IA per le aziende"
    },
    excerpt: {
      de: "Wie KI-gestützte Erklärvideos Prozesse vereinfachen und Kunden besser informieren.",
      en: "How AI-powered explainer videos simplify processes and better inform customers.",
      fr: "Comment les vidéos explicatives basées sur l'IA simplifient les processus et informent mieux les clients.",
      it: "Come i video esplicativi basati sull'IA semplificano i processi e informano meglio i clienti."
    }
  },
  {
    id: 3,
    slug: "videomarketing-trends-2025",
    date: "28.03.2025",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "Videomarketing 2025: Die wichtigsten Trends für KMU",
      en: "Video Marketing 2025: Key Trends for SMEs",
      fr: "Marketing vidéo 2025: Tendances clés pour les PME",
      it: "Video marketing 2025: Tendenze chiave per le PMI"
    },
    excerpt: {
      de: "Diese Videoformate werden im nächsten Jahr entscheidend für Unternehmenserfolg.",
      en: "These video formats will be crucial for business success next year.",
      fr: "Ces formats vidéo seront cruciaux pour le succès des entreprises l'année prochaine.",
      it: "Questi formati video saranno cruciali per il successo aziendale il prossimo anno."
    }
  },
  {
    id: 4,
    slug: "ai-vs-klassische-videoproduktion",
    date: "15.03.2025",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "AI vs. klassische Videoproduktion – Ein Kostenvergleich",
      en: "AI vs. Traditional Video Production – A Cost Comparison",
      fr: "IA vs. production vidéo traditionnelle – Une comparaison des coûts",
      it: "IA vs. produzione video tradizionale – Un confronto dei costi"
    },
    excerpt: {
      de: "Warum KI-Produktionen nicht nur günstiger, sondern auch effizienter sind.",
      en: "Why AI productions are not only cheaper but also more efficient.",
      fr: "Pourquoi les productions IA sont non seulement moins chères mais aussi plus efficaces.",
      it: "Perché le produzioni IA non sono solo più economiche ma anche più efficienti."
    }
  },
  {
    id: 5,
    slug: "coaches-berater-ai-videos",
    date: "02.03.2025",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "Wie Coaches und Berater mit AI-Videos neue Kunden gewinnen",
      en: "How Coaches and Consultants Win New Clients with AI Videos",
      fr: "Comment les coachs et consultants gagnent de nouveaux clients avec des vidéos IA",
      it: "Come coach e consulenti attirano nuovi clienti con i video IA"
    },
    excerpt: {
      de: "Maßgeschneiderte Video-Strategien für Personal Brands & Solopreneure.",
      en: "Customized video strategies for personal brands & solopreneurs.",
      fr: "Stratégies vidéo personnalisées pour les marques personnelles et entrepreneurs individuels.",
      it: "Strategie video personalizzate per personal brand e imprenditori individuali."
    }
  },
  {
    id: 6,
    slug: "social-media-ads-ki-erstellen",
    date: "20.02.2025",
    image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "Erfolgreiche Social Media Ads mit KI erstellen: So geht's",
      en: "Creating Successful Social Media Ads with AI: Here's How",
      fr: "Créer des publicités réussies sur les médias sociaux avec l'IA: Voici comment",
      it: "Creare annunci di successo sui social media con l'IA: Ecco come"
    },
    excerpt: {
      de: "Tipps & Tools, um virale KI-Videos für Instagram, TikTok & Co zu gestalten.",
      en: "Tips & tools for creating viral AI videos for Instagram, TikTok & Co.",
      fr: "Conseils et outils pour créer des vidéos IA virales pour Instagram, TikTok et autres.",
      it: "Suggerimenti e strumenti per creare video IA virali per Instagram, TikTok e altri."
    }
  },
  {
    id: 7,
    slug: "kliniken-praxen-ai-videos",
    date: "10.02.2025",
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "Warum Kliniken und Praxen auf AI-Videos setzen sollten",
      en: "Why Clinics and Practices Should Adopt AI Videos",
      fr: "Pourquoi les cliniques et cabinets devraient adopter les vidéos IA",
      it: "Perché cliniche e studi dovrebbero adottare i video IA"
    },
    excerpt: {
      de: "Vertrauen durch Erklärvideos und automatisierte Patientenkommunikation.",
      en: "Building trust through explainer videos and automated patient communication.",
      fr: "Établir la confiance grâce aux vidéos explicatives et à la communication automatisée avec les patients.",
      it: "Costruire fiducia attraverso video esplicativi e comunicazione automatizzata con i pazienti."
    }
  },
  {
    id: 8,
    slug: "video-landingpages-conversion",
    date: "01.02.2025",
    image: "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "Die besten Video-Landingpages für hohe Conversion Rates",
      en: "The Best Video Landing Pages for High Conversion Rates",
      fr: "Les meilleures pages d'atterrissage vidéo pour des taux de conversion élevés",
      it: "Le migliori landing page video per alti tassi di conversione"
    },
    excerpt: {
      de: "Diese Strukturen & Inhalte bringen Klicks in Verkäufe.",
      en: "These structures & content turn clicks into sales.",
      fr: "Ces structures et contenus transforment les clics en ventes.",
      it: "Queste strutture e contenuti trasformano i clic in vendite."
    }
  },
  {
    id: 9,
    slug: "ai-videomarketing-ecommerce",
    date: "20.01.2025",
    image: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "AI-Videomarketing für E-Commerce: Mehr Umsatz im Onlineshop",
      en: "AI Video Marketing for E-Commerce: Increasing Revenue in Your Online Shop",
      fr: "Marketing vidéo IA pour l'e-commerce: Augmenter les revenus de votre boutique en ligne",
      it: "Video marketing IA per l'e-commerce: Aumentare le entrate nel tuo negozio online"
    },
    excerpt: {
      de: "Produktvideos mit KI steigern die Kaufbereitschaft – hier ist der Beweis.",
      en: "Product videos with AI increase willingness to buy – here's the proof.",
      fr: "Les vidéos de produits avec l'IA augmentent la volonté d'achat – voici la preuve.",
      it: "I video di prodotti con l'IA aumentano la propensione all'acquisto – ecco la prova."
    }
  },
  {
    id: 10,
    slug: "zukunft-werbung-ki-gamechanger",
    date: "10.01.2025",
    image: "https://images.unsplash.com/photo-1535303311164-664fc9ec6532?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
    title: {
      de: "Zukunft der Werbung: KI als Gamechanger im Marketing",
      en: "The Future of Advertising: AI as a Game Changer in Marketing",
      fr: "L'avenir de la publicité: L'IA comme game changer dans le marketing",
      it: "Il futuro della pubblicità: L'IA come game changer nel marketing"
    },
    excerpt: {
      de: "Von Content-Automation bis Kundenbindung – was in 3 Jahren Standard ist.",
      en: "From content automation to customer retention – what will be standard in 3 years.",
      fr: "De l'automatisation du contenu à la fidélisation des clients – ce qui sera standard dans 3 ans.",
      it: "Dall'automazione dei contenuti alla fidelizzazione dei clienti – cosa sarà standard tra 3 anni."
    }
  }
];
